import { render, staticRenderFns } from "./GradeDataDetail.vue?vue&type=template&id=7705a000&scoped=true"
import script from "./GradeDataDetail.vue?vue&type=script&lang=ts"
export * from "./GradeDataDetail.vue?vue&type=script&lang=ts"
import style0 from "./GradeDataDetail.vue?vue&type=style&index=0&id=7705a000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7705a000",
  null
  
)

export default component.exports